import script from "./PublicConfiguratorView.vue?vue&type=script&setup=true&lang=js"
export * from "./PublicConfiguratorView.vue?vue&type=script&setup=true&lang=js"

import "./PublicConfiguratorView.vue?vue&type=style&index=0&id=48ac88c8&scoped=true&lang=css"
import "./PublicConfiguratorView.vue?vue&type=style&index=1&id=48ac88c8&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-48ac88c8"]])

export default __exports__